import { createApp } from 'vue'
import App from './App.vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

// Import Mapbox GL CSS
import 'mapbox-gl/dist/mapbox-gl.css';


// Import BootstrapVue 3
import {BootstrapVue3} from 'bootstrap-vue-3'

// Create the Vue application
const app = createApp(App)

// Use BootstrapVue3
app.use(BootstrapVue3)


// Mount the app
app.mount('#app')